var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackinsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(428 1740)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 32,
    height: 32,
    transform: "translate(-428 -1740)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af2da8f3726c5aa836b9ea2eeab70e0c",
    d: "M23.228,6.788h0a1.661,1.661,0,1,0,1.661,1.661A1.661,1.661,0,0,0,23.228,6.788Zm6.366,3.349a10.5,10.5,0,0,0-.637-3.363,6.836,6.836,0,0,0-1.605-2.449A6.5,6.5,0,0,0,24.9,2.733a10.1,10.1,0,0,0-3.363-.65C20.073,2,19.6,2,15.839,2s-4.235,0-5.7.083a10.1,10.1,0,0,0-3.363.65A6.615,6.615,0,0,0,4.325,4.325,6.5,6.5,0,0,0,2.733,6.774a10.1,10.1,0,0,0-.65,3.363C2,11.6,2,12.074,2,15.839s0,4.235.083,5.7a10.1,10.1,0,0,0,.65,3.363,6.5,6.5,0,0,0,1.591,2.449,6.615,6.615,0,0,0,2.449,1.591,10.1,10.1,0,0,0,3.363.65c1.467.083,1.937.083,5.7.083s4.235,0,5.7-.083a10.1,10.1,0,0,0,3.363-.65,6.5,6.5,0,0,0,2.449-1.591A6.712,6.712,0,0,0,28.957,24.9a10.5,10.5,0,0,0,.637-3.363c0-1.467.083-1.937.083-5.7S29.677,11.6,29.594,10.137ZM27.1,21.374a7.763,7.763,0,0,1-.471,2.574,4.235,4.235,0,0,1-1.038,1.591A4.414,4.414,0,0,1,24,26.577a7.763,7.763,0,0,1-2.574.471c-1.384.069-1.9.083-5.535.083s-4.152,0-5.535-.083a7.929,7.929,0,0,1-2.685-.415,4.525,4.525,0,0,1-1.522-1.038A4.152,4.152,0,0,1,5.128,24a7.667,7.667,0,0,1-.554-2.629c0-1.384-.083-1.9-.083-5.535s0-4.152.083-5.535a7.667,7.667,0,0,1,.484-2.629A4.152,4.152,0,0,1,6.152,6.152,4.345,4.345,0,0,1,7.674,5.044,7.93,7.93,0,0,1,10.3,4.574c1.384,0,1.9-.083,5.535-.083s4.152,0,5.535.083a7.763,7.763,0,0,1,2.574.471,4.235,4.235,0,0,1,1.647,1.107,4.235,4.235,0,0,1,1.038,1.522A7.763,7.763,0,0,1,27.1,10.3c.069,1.384.083,1.9.083,5.535S27.172,19.99,27.1,21.374ZM15.839,8.739a7.085,7.085,0,1,0,5.033,2.07,7.1,7.1,0,0,0-5.033-2.07Zm0,11.707a4.608,4.608,0,1,1,4.608-4.608,4.608,4.608,0,0,1-4.608,4.608Z",
    transform: "translate(-427.839 -1739.839)",
    fill: "#040403"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackinsta);
export default __webpack_public_path__ + "static/media/blackinsta.2a0cc0f143e36c7e2558b870868ec06d.svg";
export { ForwardRef as ReactComponent };